export const MESSAGE = {
  INVALID_CEP: {
    error: true,
    message: 'Opa, CEP não encontrado. Confira se o número digitado tá certinho e tente de novo :)',
  },
  INCOMPLETE_CEP: {
    error: true,
    message: 'Hummm, parece que o CEP tá incompleto. Digite 8 números, sem caracteres especiais.',
  },
  OUT_OF_STOCK: {
    error: true,
    message: 'Produto sem estoque.',
  },
  CANT_DELIVER: {
    error: true,
    message: 'Desculpe, essa loja não faz entrega desse produto para este CEP.',
  },
  DEFAULT: {
    error: true,
    message: 'Cálculo de frete indisponível no momento.',
  },
  DELIVER_AT_CORREIOS: {
    error: false,
    message: 'Entregamos na agência dos correios mais próxima.',
  },
  CROSS_DELIVERY: {
    error: false,
    message:
      'Este produto esgotou-se na sua região e será enviado de um centro de distribuição mais distante. Por isso, o prazo e o valor de frete serão maiores.',
  },
  STORE_NOT_FOUND: {
    message: 'Desculpe, esse produto não está disponível para o seu CEP. Que tal tentar outro CEP?',
  },
  STORE_INITIAL_MESSAGE: {
    message: 'Digite o seu CEP para encontrar as lojas perto de você :)',
  },
  DEFAULT_FREIGHT: {
    error: false,
    message: '',
  },
};

export const getFreightErrorMessage = code => MESSAGE[code] || MESSAGE.DEFAULT;
